import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { HAIR_HUB, HAIR_GUIDES } from "@/data/hairGuides";

export const HairGuidesTeaser = () => (
  <section
    id="conseils-cheveux-afro"
    data-testid="home-hair-guides"
    className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-12 md:py-16"
  >
    <div className="flex items-center gap-2 mb-3">
      <Sparkles className="w-5 h-5 text-[var(--oz-gold)]" />
      <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[var(--oz-gold)]">
        Conseils cheveux afro
      </span>
    </div>
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
      <h2 className="font-serif text-3xl sm:text-4xl text-[var(--oz-text)] max-w-2xl leading-tight">
        Pousse, casse, chute : nos guides pour cheveux afro et crépus
      </h2>
      <Link
        to={HAIR_HUB.path}
        data-testid="home-hair-guides-all"
        className="inline-flex items-center gap-2 text-sm font-semibold text-[var(--oz-text)] underline underline-offset-4 hover:text-[var(--oz-gold)] transition-colors"
      >
        Tous les conseils <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
    <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {HAIR_GUIDES.map((g) => (
        <Link
          key={g.slug}
          to={`${HAIR_HUB.path}/${g.slug}`}
          data-testid={`home-hair-guide-${g.slug}`}
          className="group flex items-center justify-between gap-3 rounded-2xl border border-[var(--oz-border)] bg-white px-5 py-4 hover:border-[var(--oz-gold)] transition-colors"
        >
          <span className="font-semibold text-[var(--oz-text)]">{g.breadcrumb}</span>
          <ArrowRight className="w-4 h-4 flex-shrink-0 text-[var(--oz-gold)] group-hover:translate-x-0.5 transition-transform" />
        </Link>
      ))}
    </div>
  </section>
);
